import { render, staticRenderFns } from "./OrganisationAdmin.vue?vue&type=template&id=77dc5fd7&scoped=true&"
import script from "./OrganisationAdmin.vue?vue&type=script&lang=js&"
export * from "./OrganisationAdmin.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationAdmin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrganisationAdmin.vue?vue&type=style&index=1&id=77dc5fd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dc5fd7",
  null
  
)

export default component.exports